export type ConsentCategory = "necessary" | "all";

const COOKIE_NAME = "cookie_consent";
const CONSENT_CHANGE_EVENT = "cookie-consent-change";
const CONSENT_OPEN_EVENT = "cookie-consent-open";

export const getConsent = (): ConsentCategory | null => {
  const match = document.cookie.match(
    new RegExp("(^| )" + COOKIE_NAME + "=([^;]+)")
  );
  const value = match ? match[2] : null;
  return value === "all" || value === "necessary" ? value : null;
};

export const setConsent = (value: ConsentCategory) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
  document.cookie = `${COOKIE_NAME}=${value};expires=${expires.toUTCString()};path=/`;
  window.dispatchEvent(
    new CustomEvent(CONSENT_CHANGE_EVENT, { detail: value })
  );
};

export const openConsentSettings = () => {
  window.dispatchEvent(new CustomEvent(CONSENT_OPEN_EVENT));
};

export const onConsentChange = (cb: (value: ConsentCategory) => void) => {
  const handler = (e: Event) => cb((e as CustomEvent<ConsentCategory>).detail);
  window.addEventListener(CONSENT_CHANGE_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGE_EVENT, handler);
};

export const onConsentOpenRequest = (cb: () => void) => {
  window.addEventListener(CONSENT_OPEN_EVENT, cb);
  return () => window.removeEventListener(CONSENT_OPEN_EVENT, cb);
};
